import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="pdg-serif text-2xl text-[hsl(var(--pdg-gold))] animate-pulse">PDG</div>
    </div>
  );
}

// Requires any authenticated user
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  return children;
}

// Requires a verified investor (or admin)
export function RequireVerified({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!isAdmin && user.status !== "verified") return <Navigate to="/access-pending" replace />;
  return children;
}

// Requires admin/service
export function RequireAdmin({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!isAdmin) return <Navigate to="/deals" replace />;
  return children;
}
